/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ActivityFilter = "CurrentUser" | "CurrentUserOrInvited" | "Invited" | "%future added value";
export type SortDirection = "Ascending" | "Descending" | "%future added value";
export type SortType = "FullName" | "Status" | "%future added value";
export type AdminSelectQueryVariables = {
    orgRelayId: string;
    sortType: SortType;
    sortDirection: SortDirection;
    searchQuery?: string | null | undefined;
    pageToken?: string | null | undefined;
    fetchNext?: boolean | null | undefined;
    limit?: number | null | undefined;
    teamId?: string | null | undefined;
    billingGroupId?: string | null | undefined;
    activityFilter: ActivityFilter;
};
export type AdminSelectQueryResponse = {
    readonly org: {
        readonly id?: string | undefined;
        readonly " $fragmentRefs": FragmentRefs<"AdminSelect_org">;
    } | null;
};
export type AdminSelectQuery = {
    readonly response: AdminSelectQueryResponse;
    readonly variables: AdminSelectQueryVariables;
};



/*
query AdminSelectQuery(
  $orgRelayId: ID!
  $sortType: SortType!
  $sortDirection: SortDirection!
  $searchQuery: String
  $pageToken: String
  $fetchNext: Boolean
  $limit: Int
  $teamId: String
  $billingGroupId: String
  $activityFilter: ActivityFilter!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      id
      ...AdminSelect_org_5Y1qI
    }
    id
  }
}

fragment AdminSelect_org_5Y1qI on Org {
  id
  orgPersonListPaginatedErrorable(sortType: $sortType, sortDirection: $sortDirection, searchQuery: $searchQuery, pageToken: $pageToken, fetchNext: $fetchNext, limit: $limit, teamId: $teamId, billingGroupId: $billingGroupId, activityFilter: $activityFilter) {
    __typename
    ... on GraphEntityError {
      message
    }
    ... on OrgPersonListPaginated {
      inputQuery
      nextPersonId
      previousPersonId
      searchPersons {
        person {
          primaryCalendarId
          userId
          personId
          signUpMillis
          isYou
          primaryBillingGroupIdErrorable {
            __typename
            ... on PrimaryBillingGroupId {
              primaryBillingGroupId
            }
            ... on GraphEntityError {
              message
              statusCode
            }
          }
          profile {
            givenName
            familyName
            externalImageUrl
          }
          id
        }
        status
      }
    }
  }
  billingGroups {
    __typename
    ... on BillingGroupList {
      list {
        id
        name
        createdAtMillis
        invitePolicy
        manualMembers {
          __typename
          ... on BillingGroupManualMemberList {
            list {
              externalUserId
              calendarId
              userId
              personId
              orgPerson {
                __typename
                ... on OrgPerson {
                  userId
                  personId
                  primaryCalendarId
                  isYou
                  signUpMillis
                  profile {
                    givenName
                    familyName
                  }
                }
                ... on GraphEntityError {
                  message
                  statusCode
                }
                ... on Node {
                  __isNode: __typename
                  id
                }
              }
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
        adminOrgPersons {
          __typename
          ... on OrgPersonList {
            list {
              userId
              personId
              primaryCalendarId
              isYou
              signUpMillis
              profile {
                givenName
                familyName
              }
              id
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "activityFilter"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "billingGroupId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchNext"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageToken"
    } as any, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchQuery"
    } as any, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortDirection"
    } as any, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortType"
    } as any, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "teamId"
    } as any, v10 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v12 = [
        {
            "kind": "Variable",
            "name": "activityFilter",
            "variableName": "activityFilter"
        } as any,
        {
            "kind": "Variable",
            "name": "billingGroupId",
            "variableName": "billingGroupId"
        } as any,
        {
            "kind": "Variable",
            "name": "fetchNext",
            "variableName": "fetchNext"
        } as any,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        } as any,
        {
            "kind": "Variable",
            "name": "pageToken",
            "variableName": "pageToken"
        } as any,
        {
            "kind": "Variable",
            "name": "searchQuery",
            "variableName": "searchQuery"
        } as any,
        {
            "kind": "Variable",
            "name": "sortDirection",
            "variableName": "sortDirection"
        } as any,
        {
            "kind": "Variable",
            "name": "sortType",
            "variableName": "sortType"
        } as any,
        {
            "kind": "Variable",
            "name": "teamId",
            "variableName": "teamId"
        } as any
    ], v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signUpMillis",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v20 = {
        "kind": "InlineFragment",
        "selections": [
            (v14 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "familyName",
        "storageKey": null
    } as any, v23 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            (v21 /*: any*/),
            (v22 /*: any*/)
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/),
                (v6 /*: any*/),
                (v7 /*: any*/),
                (v8 /*: any*/),
                (v9 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "AdminSelectQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v10 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v11 /*: any*/),
                                {
                                    "args": (v12 /*: any*/),
                                    "kind": "FragmentSpread",
                                    "name": "AdminSelect_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v4 /*: any*/),
                (v8 /*: any*/),
                (v7 /*: any*/),
                (v6 /*: any*/),
                (v5 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v9 /*: any*/),
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "AdminSelectQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v10 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v13 /*: any*/),
                        (v11 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v12 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgPersonListPaginatedErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v13 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v14 /*: any*/)
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "inputQuery",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "nextPersonId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "previousPersonId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SearchPerson",
                                                    "kind": "LinkedField",
                                                    "name": "searchPersons",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "OrgPerson",
                                                            "kind": "LinkedField",
                                                            "name": "person",
                                                            "plural": false,
                                                            "selections": [
                                                                (v15 /*: any*/),
                                                                (v16 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v18 /*: any*/),
                                                                (v19 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "primaryBillingGroupIdErrorable",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v13 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "primaryBillingGroupId",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "PrimaryBillingGroupId",
                                                                            "abstractKey": null
                                                                        },
                                                                        (v20 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "UserProfile",
                                                                    "kind": "LinkedField",
                                                                    "name": "profile",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v21 /*: any*/),
                                                                        (v22 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "externalImageUrl",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v11 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "status",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "OrgPersonListPaginated",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "billingGroups",
                                    "plural": false,
                                    "selections": [
                                        (v13 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "BillingGroup",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v11 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "name",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "createdAtMillis",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "invitePolicy",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "manualMembers",
                                                            "plural": false,
                                                            "selections": [
                                                                (v13 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "BillingGroupManualMember",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalUserId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "calendarId",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v16 /*: any*/),
                                                                                (v17 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "orgPerson",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v13 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                (v16 /*: any*/),
                                                                                                (v17 /*: any*/),
                                                                                                (v15 /*: any*/),
                                                                                                (v19 /*: any*/),
                                                                                                (v18 /*: any*/),
                                                                                                (v23 /*: any*/)
                                                                                            ],
                                                                                            "type": "OrgPerson",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v20 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                (v11 /*: any*/)
                                                                                            ],
                                                                                            "type": "Node",
                                                                                            "abstractKey": "__isNode"
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "BillingGroupManualMemberList",
                                                                    "abstractKey": null
                                                                },
                                                                (v20 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "adminOrgPersons",
                                                            "plural": false,
                                                            "selections": [
                                                                (v13 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "OrgPerson",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v16 /*: any*/),
                                                                                (v17 /*: any*/),
                                                                                (v15 /*: any*/),
                                                                                (v19 /*: any*/),
                                                                                (v18 /*: any*/),
                                                                                (v23 /*: any*/),
                                                                                (v11 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "OrgPersonList",
                                                                    "abstractKey": null
                                                                },
                                                                (v20 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "BillingGroupList",
                                            "abstractKey": null
                                        },
                                        (v20 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "2d578552d10cde23293cbb1dca96d6c5",
            "id": null,
            "metadata": {},
            "name": "AdminSelectQuery",
            "operationKind": "query",
            "text": "query AdminSelectQuery(\n  $orgRelayId: ID!\n  $sortType: SortType!\n  $sortDirection: SortDirection!\n  $searchQuery: String\n  $pageToken: String\n  $fetchNext: Boolean\n  $limit: Int\n  $teamId: String\n  $billingGroupId: String\n  $activityFilter: ActivityFilter!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      id\n      ...AdminSelect_org_5Y1qI\n    }\n    id\n  }\n}\n\nfragment AdminSelect_org_5Y1qI on Org {\n  id\n  orgPersonListPaginatedErrorable(sortType: $sortType, sortDirection: $sortDirection, searchQuery: $searchQuery, pageToken: $pageToken, fetchNext: $fetchNext, limit: $limit, teamId: $teamId, billingGroupId: $billingGroupId, activityFilter: $activityFilter) {\n    __typename\n    ... on GraphEntityError {\n      message\n    }\n    ... on OrgPersonListPaginated {\n      inputQuery\n      nextPersonId\n      previousPersonId\n      searchPersons {\n        person {\n          primaryCalendarId\n          userId\n          personId\n          signUpMillis\n          isYou\n          primaryBillingGroupIdErrorable {\n            __typename\n            ... on PrimaryBillingGroupId {\n              primaryBillingGroupId\n            }\n            ... on GraphEntityError {\n              message\n              statusCode\n            }\n          }\n          profile {\n            givenName\n            familyName\n            externalImageUrl\n          }\n          id\n        }\n        status\n      }\n    }\n  }\n  billingGroups {\n    __typename\n    ... on BillingGroupList {\n      list {\n        id\n        name\n        createdAtMillis\n        invitePolicy\n        manualMembers {\n          __typename\n          ... on BillingGroupManualMemberList {\n            list {\n              externalUserId\n              calendarId\n              userId\n              personId\n              orgPerson {\n                __typename\n                ... on OrgPerson {\n                  userId\n                  personId\n                  primaryCalendarId\n                  isYou\n                  signUpMillis\n                  profile {\n                    givenName\n                    familyName\n                  }\n                }\n                ... on GraphEntityError {\n                  message\n                  statusCode\n                }\n                ... on Node {\n                  __isNode: __typename\n                  id\n                }\n              }\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n        adminOrgPersons {\n          __typename\n          ... on OrgPersonList {\n            list {\n              userId\n              personId\n              primaryCalendarId\n              isYou\n              signUpMillis\n              profile {\n                givenName\n                familyName\n              }\n              id\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '19fadf8e6ba5a33e33976f3f6e501d69';
export default node;
